/**
 * The six step kinds as a learner sees them (contract §10.0.1): one icon and one "public"
 * i18n key per kind, so the pathway home's rows and any other learner surface name a kind
 * the same way. An unknown kind (a newer server) reads as a reading, never as a raw id.
 */
import { CalendarClock, FileText, GraduationCap, HelpCircle, PenLine, Play } from "lucide-react";

const KIND_ICONS = Object.freeze({
  video: Play,
  reading: FileText,
  practice: PenLine,
  quiz: HelpCircle,
  live: CalendarClock,
  course: GraduationCap,
});

const KIND_KEYS = Object.freeze({
  video: "pathways.kind.video",
  reading: "pathways.kind.reading",
  practice: "pathways.kind.practice",
  quiz: "pathways.kind.quiz",
  live: "pathways.kind.live",
  course: "pathways.kind.course",
});

/** @returns {React.ComponentType} the lucide icon of a step kind */
export const stepKindIcon = (kind) => KIND_ICONS[kind] || FileText;

/** @returns {string} the kind's name, through the caller's bound `t` for "public" */
export const stepKindLabel = (t, kind) => t(KIND_KEYS[kind] || KIND_KEYS.reading);
